import Footer from "./Footer";

const introLogo = "/reportImages/intro-logo.png";
const farmsImage = "/reportImages/farms.png";
const websiteIcon = "/reportImages/website.png";
const emailIcon = "/reportImages/email.png";
const phoneIcon = "/reportImages/phone.png";

const AboutPage = () => {
  return (
    <div
      style={{
        borderTop: "15px solid #005a4e",
      }}
    >
      <div className="about-page" id="about-page">
        <img src={introLogo} alt="PAR Logo" className="about-logo " />
        <div className="logo-divider"></div>

        <p className="intro-text">
          Pakistan Agriculture Research (PAR) is an agri think tank on a mission
          to provide agricultural data to players across the agri-supply chain.
          PAR covers the market mechanisms of major crops of Pakistan and
          prepares efficient digital data services that connect Pakistani
          farmers, brokers, traders and manufacturers directly to the
          agriculture information they need.
        </p>

        <p className="intro-text">
          With sister companies, Fund Marketing International (a commodity
          indenting brokerage firm) and Zarai Mandi (B2C WhatsApp daily
          commodity price service aggregating data from grain markets – Ghalla
          Mandis), PAR can serve you across Pakistan’s farming and agricultural
          supply chains.
        </p>

        <img src={farmsImage} alt="Farms View" className="farms-image" />

        <p className="intro-text">
          PAR aims to excel as Pakistan’s premier agricultural research firm,
          enhancing farmer productivity, reducing losses, and promoting
          data-driven decision-making. Leveraging our network, we address market
          inefficiencies and ensure supply chain connectivity. Our vision
          focuses on boosting farmer yields, minimizing losses, and ensuring
          data accessibility for all stakeholders. Through our decade-long data
          bank, we empower B2B clients with strategic commodity insights,
          benefiting the entire agri-supply chain.
        </p>

        <p className="intro-text">
          Here at PAR, our ethos is to be a socially responsible enterprise that
          empowers farmers, agriculturalists & industrialists by ensuring access
          to vital information to reconfigure agriculture operations across
          Pakistan.
        </p>

        <div className="disclaimer-box">
          <strong>Disclaimer:</strong> <br />
          This report is produced by Pakistan Agriculture Research (PAR)
          exclusively for its subscribers. The data contained in this report has
          been collected from secondary sources, IRSA and PMDA, and has been
          thoroughly analyzed by PAR. Only PAR holds the right to distribute or
          sell this report; it is not available for purchase, sale, or any
          related activities by any third party. Although the information is
          sourced from channels believed to be reliable, its accuracy is not
          guaranteed. The opinions expressed herein are subject to revision
          without prior notice. All material contained in this report is the
          exclusive property of PAR, and any unauthorized use, reproduction, or
          distribution of this information is subject to legal action.
        </div>

        <div className="contact-us-box">
          <span>
            <img src={websiteIcon} height={20} alt="Website Icon" className="mx-1" />{" "}
            <a
              href="https://www.par.com.pk"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.par.com.pk
            </a>
          </span>
          <span>
            <img src={emailIcon} height={20} alt="Email Icon" className="mx-1" />{" "}
            <a href="mailto:support@par.com.pk">support@par.com.pk</a>
          </span>
          <span>
            <img src={phoneIcon} height={20} alt="Phone Icon" className="mx-1" />
            <a href="tel:02132427386">021-32427386</a>
          </span>
        </div>
        <div style={{ marginTop: "10px" }}>
          <Footer
            footerNumber="2"
            footerText={"Weekly Water & Weather Report"}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
